import Flex from './flex.vue'
export default Flex



// WEBPACK FOOTER //
// ./src/components/flex/index.js